"use strict";
exports.__esModule = true;
var basic_chart_component_1 = require("../../../../basic-component/basic-chart.component");
var smart_text_directive_1 = require("../../../../smart-text/app/js/plumbing/smart-text-directive");
angular.module('smartorg.r6.acts.introBox').directive('showIntroBox', ['$timeout', '$rootScope', function ($timeout, $rootScope) {
        return {
            restrict: 'E',
            template: require('../../template/introBox.html'),
            scope: {
                smartorg: '=',
                menu: '='
            },
            link: function (scope) {
                scope.showAlert = function (type, title, msg) {
                    scope.$emit('workbench:alert', {
                        "type": type,
                        "title": title,
                        "message": msg
                    });
                };
                scope.updateDescription = function (nodeId, description) {
                    scope.$emit('workbench:update_description', {
                        'description': description,
                        'nodeID': nodeId
                    });
                };
                scope.initIntro = function () {
                    scope.intro = {
                        current: "",
                        original: ""
                    };
                };
                /**
                 * Save description / guidance for a node.
                 *
                 * @param nodeId {string} This should be the selected node.
                 *     The node id is passed into saveDescription / saveGuidance, and this
                 *     is called there.
                 * @param introMessage {string} Html format descriptions / guidance.
                 *     Do not encode the input, this will handle
                 *     the encoding.
                 * @param callback {Function} What to do after success.
                 */
                scope.saveIntroMessage = function (nodeId, introMessage, callback) {
                    scope.btnFuncs.saving = true;
                    if (!introMessage) {
                        introMessage = '&nbsp;';
                    }
                    var nodeID = nodeId;
                    if (scope.title == 'Description') {
                        scope.smartorg.saveDescripton(btoa(nodeId), btoa(introMessage)).then(function () {
                            scope.updateDescription(nodeId, introMessage);
                            callback();
                            scope.btnFuncs.saving = false;
                            scope.$emit('workbench:last_updated', { nodeID: nodeID });
                        })["catch"](function (err) {
                            scope.showAlert("danger", "Server Error " + err.status, err.message);
                            scope.btnFuncs.saving = false;
                        });
                    }
                    else if (scope.title == 'Guidance') {
                        scope.smartorg.saveGuidance(btoa(nodeId), btoa(introMessage)).then(function () {
                            callback();
                            scope.btnFuncs.saving = false;
                            scope.$emit('workbench:last_updated', { nodeID: nodeID });
                        })["catch"](function (err) {
                            scope.showAlert("danger", "Server Error " + err.status, err.message);
                            scope.btnFuncs.saving = false;
                        });
                    }
                };
                scope.$on('command:GUIDANCE', function (event, args) {
                    scope.title = "Guidance";
                    scope.initIntro();
                    if (args.node) {
                        scope.nodeId = args.node._id;
                        scope.nodeName = args.node.name;
                        scope.loadGuidance(args.node);
                        scope.showEditIfEmpty();
                    }
                    scope.menu = menu;
                    $timeout();
                });
                scope.loadGuidance = function (node) {
                    scope.smartorg.getGuidance(node._id).then(function (guidance) {
                        scope.intro.original = guidance ?
                            decodeURIComponent(atob(guidance)) : "";
                        scope.formattedHtml = (0, smart_text_directive_1.formatHTML)(angular.copy(scope.intro.original));
                        scope.readonly = node.permissions === "r";
                        scope.intro.current = scope.intro.original;
                        scope.editorEnabled = scope.intro.current === "" ||
                            scope.intro.current === "&nbsp;";
                        scope.$emit('workbench:loading', {
                            'load': false
                        });
                        $timeout();
                    })["catch"](function (err) {
                        scope.showAlert("danger", "Server Error " + err.status, err.message);
                    });
                };
                scope.$on('command:DESCRIPTION', function (event, args) {
                    scope.title = 'Description';
                    scope.initIntro();
                    if (args.node) {
                        scope.nodeId = args.node._id;
                        scope.nodeName = args.node.name;
                        scope.loadDescription(args.node);
                        scope.showEditIfEmpty();
                    }
                    scope.menu = menu;
                    $timeout();
                });
                scope.loadDescription = function (node) {
                    scope.smartorg.nodeByPost(node._id).then(function (val) {
                        node.description = val.description;
                        scope.intro.original = node.description ?
                            decodeURIComponent(atob(node.description)) : "";
                        scope.formattedHtml = (0, smart_text_directive_1.formatHTML)(angular.copy(scope.intro.original));
                        scope.readonly = node.permissions === "r";
                        scope.intro.current = scope.intro.original;
                        scope.editorEnabled = scope.intro.current === "" ||
                            scope.intro.current === "&nbsp;";
                        scope.$emit('workbench:loading', {
                            'load': false
                        });
                        $timeout();
                    })["catch"](function (err) {
                        scope.showAlert("danger", "Server Error " + err.status, err.message);
                    });
                };
                /**
                 * If the introduction box is empty, show edit mode by default.
                 * Unless it is read only node.
                 *
                 * In that case, scope.readonly will stop user from
                 * entering the edit mode.
                 */
                scope.showEditIfEmpty = function () {
                    scope.showCloseBtn = false;
                    if (scope.intro.current === scope.intro.original) {
                        scope.showCloseBtn = scope.intro.original != "" &&
                            scope.intro.original != "&nbsp;";
                    }
                    $rootScope.smartorgDirty = scope.intro.current !== scope.intro.original;
                };
                scope.btnFuncs = {
                    saving: false,
                    edit: function () {
                        scope.editorEnabled = true;
                        scope.showCloseBtn = true;
                        scope.intro.current = scope.intro.original;
                    },
                    close: function () {
                        scope.editorEnabled = false;
                        scope.showCloseBtn = false;
                        scope.intro.current = scope.intro.original;
                    },
                    reset: function () {
                        scope.editorEnabled = true;
                        scope.intro.current = scope.intro.original;
                        scope.showEditIfEmpty();
                    },
                    save: function () {
                        var tosave = scope.intro.current.replace(/<a href=/, "<a target='_blank' href=");
                        scope.btnFuncs.saving = true;
                        $timeout(function () {
                            scope.saveIntroMessage(scope.nodeId, encodeURIComponent(tosave), function () {
                                scope.intro.original = scope.intro.current = tosave;
                                scope.formattedHtml = (0, smart_text_directive_1.formatHTML)(angular.copy(scope.intro.original));
                                scope.editorEnabled = scope.intro.current === "" ||
                                    scope.intro.current === "&nbsp;";
                                scope.showEditIfEmpty();
                                $timeout();
                            });
                        }, 500);
                    }
                };
                var menu = [{
                        'name': 'Edit',
                        'class': 'btn btn-xs btn-primary',
                        'show': function () {
                            return !scope.editorEnabled && !scope.readonly;
                        },
                        'callback': function () {
                            scope.btnFuncs.edit();
                        }
                    }, {
                        'name': 'Save',
                        'class': 'btn btn-xs btn-danger',
                        'show': function () {
                            return scope.editorEnabled && scope.intro.current != scope.intro.original && !scope.btnFuncs.saving;
                        },
                        'callback': function () {
                            scope.btnFuncs.save();
                        }
                    }, {
                        'name': 'Reset',
                        'class': 'btn btn-xs btn-primary',
                        'show': function () {
                            return scope.editorEnabled && scope.intro.current != scope.intro.original && !scope.btnFuncs.saving;
                        },
                        'callback': function () {
                            scope.btnFuncs.reset();
                        }
                    }, {
                        'name': '',
                        'class': 'btn btn-xs btn-danger',
                        'icon': 'fa fa-spinner fa-spin fa-fw',
                        'show': function () {
                            return scope.btnFuncs.saving;
                        }
                    }, {
                        'name': 'Close',
                        'class': 'btn btn-xs btn-primary',
                        'show': function () {
                            return scope.editorEnabled && scope.showCloseBtn;
                        },
                        'callback': function () {
                            scope.btnFuncs.close();
                        }
                    }, {
                        'name': 'Export',
                        'items': [{
                                'name': 'Word Document',
                                'callback': function () {
                                    var title = scope.title + '_for_' + scope.nodeName;
                                    (0, basic_chart_component_1.exportHTML)(scope.formattedHtml, title);
                                }
                            }]
                    }];
            }
        };
    }]);
//# sourceMappingURL=intro-box-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/intro-box/app/js/plumbing/intro-box-directive.js